// extracted by mini-css-extract-plugin
module.exports = {"spinnerRoot":"feedback_spinnerRoot__1YYki","root":"feedback_root__2Ny9m"};